import * as React from 'react';
import { IGhBuyboxResources } from '../gh-buybox.props.autogenerated';
import { IInventoryStatus } from '../utilities/inventory-status.util';

export interface IInventoryLabelProps {
    status: IInventoryStatus;
    resources: IGhBuyboxResources;
    toOrderReturnPolicyUrl?: string;
    className?: string;
}

/**
 * Renders the inventory label based on the inventory status
 */
export const InventoryLabel: React.FC<IInventoryLabelProps> = ({
    status,
    resources,
    toOrderReturnPolicyUrl = '/pages/return-policy',
    className = 'gh-buybox__inventory-label'
}) => {
    switch (status.type) {
        case 'to-order':
            return (
                <div className={`${className} ${className}--to-order`}>
                    <div className={`${className}__header`}>
                        <strong>{resources.inventoryToOrderLabel}</strong>
                    </div>
                    <div className={`${className}__description`}>
                        {resources.inventoryToOrderDescription}{' '}
                        <a href={toOrderReturnPolicyUrl} className={`${className}__link`}>
                            {resources.inventoryToOrderLinkText}
                        </a>
                        . {resources.inventoryToOrderSuffix}
                    </div>
                </div>
            );

        case 'central-warehouse':
            return <div className={`${className} ${className}--in-stock`}>{resources.inventoryCentralWarehouseLabel}</div>;

        case 'in-store':
            return (
                <div className={`${className} ${className}--in-store`}>
                    <div className={`${className}__label`}>{resources.inventoryInStoreLabel}</div>
                </div>
            );

        case 'out-of-stock':
            return <div className={`${className} ${className}--out-of-stock`}>{resources.inventoryOutOfStockLabel}</div>;

        default:
            return null;
    }
};

export default InventoryLabel;
